import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useVerifyOtpMutation } from '../State/Api/LoginApiSlice';
import { useFormik } from 'formik';

function Otp() {
  const navigate = useNavigate();
  const [verifyOtp] = useVerifyOtpMutation();
  const location = useLocation();
  const email = location.state?.email;

  const formik = useFormik({
    initialValues: {
      otp: '',
      EmailID: email || ''
    },
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append('vocde', values.otp);
        formData.append('EmailID', values.EmailID);
        const result = await verifyOtp(formData).unwrap();
        if(result?.result_Code!==200){
          alert("Invalid OTP");
        }else{
            navigate('/ChangePassword', { state: { email: values.EmailID } });
        }
        
      } catch (error) {
     
      }
    },
    enableReinitialize: true
  });

  // To manage individual OTP input fields
  const otpLength = 6;
  const [otpArray, setOtpArray] = useState(Array(otpLength).fill(''));
  const inputRefs = useRef([]);

  const handleOtpChange = (value, index) => {
    const updatedOtp = [...otpArray];
    updatedOtp[index] = value;
    setOtpArray(updatedOtp);

    // Move focus to next input if filled
    if (value && index < otpLength - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    formik.setFieldValue('otp', updatedOtp.join(''));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otpArray[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <>
      <section className="section-bg" style={{ width: '100%', height: "100%", display: "flex", position: "relative" }}>
        <div className="div-totLg0piuG">
          <form onSubmit={formik.handleSubmit} className="form-ym5zR5QPwa rounded-4">
            <div className="d-flex flex-column align-items-center justify-content-center mb-4">
              <h4 className="fw-bold mb-4">OTP</h4>
              <span className="">We have sent a 6 digit OTP to your registered Email.</span>
            </div>

            <hr className="mb-4" />

            <div className="d-flex justify-content-center mb-4">
              <div className="d-flex gap-2">
                {otpArray.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value.replace(/\D/, ''), index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                    className="text-center border rounded-2"
                    style={{ width: "3rem", height: "3rem", fontSize: "1.5rem" }}
                  />
                ))}
              </div>
            </div>

            <button
              type="submit"
              className="border-0 rounded-2 d-flex align-items-center justify-content-center"
              disabled={formik.isSubmitting || formik.values.otp.length !== 6}
              style={{
                width: '100%',
                background: "#367588",
                color: '#fff',
                padding: ".5rem .5rem",
                opacity: formik.isSubmitting ? 0.7 : 1,
                cursor: formik.isSubmitting ? 'not-allowed' : 'pointer'
              }}
            >
              {formik.isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Verifying...
                </>
              ) : (
                "Verify OTP"
              )}
            </button>
          </form>
        </div>

        <div className="img-V6fpDDVfc2">
          <img src="/Images/BG_SignIn.png" alt="" />
        </div>
      </section>
    </>
  );
}

export default Otp;
